module.exports = __webpack_public_path__ + "static/Classroom-Activity-1-3-Competing-and-Comparing-Looks-ES-e8364f136e01ea8aae62d64208791dac.pdf";